<template>
  <v-container>
    <v-row>
      <MobileCol>
        <v-skeleton-loader
          :loading="isLoading"
          transition="expand-transition"
          type="card"
        >
          <div>
            <div class="text-h5">{{ $$t('title') }}</div>
          </div>
        </v-skeleton-loader>
        <v-btn
          :to="{ name: 'membership-EditIncident' }"
          block
          class="mt-5 mb-5"
          color="success"
        >
          {{ $$t('new') }}
        </v-btn>
        <incidents-map
          ref="incidentMap"
          :incidents="localIncidents"
          :currentCoords="currentCoords"
        />
        <back-button />
      </MobileCol>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { gmapApi } from 'vue2-google-maps';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import location from '../mixins/location';
import BackButton from '../components/BackButton.vue';
import MobileCol from '../components/MobileCol.vue';
import IncidentsMap from '../components/IncidentsMap.vue';

export default {
  components: {
    BackButton,
    MobileCol,
    IncidentsMap,
  },
  name: 'Incidents',
  module: 'Membership',
  mixins: [loading, location],
  computed: {
    /** Vuex states
     */
    ...mapState('incidents', ['incidents', 'incidentsInMyArea']),
    google: gmapApi,
    currentCoords() {
      if (!this.currentPosition) {
        return { lat: -28, lng: 26 };
      }
      const { coords } = this.currentPosition;
      return {
        lat: coords.latitude,
        lng: coords.longitude,
      };
    },
    localIncidents() {
      const { incidents, incidentsInMyArea } = this;
      const result = [...incidents ?? [], ...incidentsInMyArea ?? []];
      return result.map((r) => {
        const incident = { ...r };
        const currentDate = new Date();
        const incidentDate = new Date(r.created);
        const totalMilliseconds = Math.abs(currentDate - incidentDate);
        incident.isRecent = totalMilliseconds < 43200000;
        return incident;
      });
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.refresh();
    await this.LOAD_incidentsInMyArea(this.currentCoords);
    await this.$refs.incidentMap?.mapToBounds();
    await this.LOAD_incidents();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('incidents', ['LOAD_incidentsInMyArea', 'LOAD_incidents']),
  },
};
</script>

<docs>
# EditIncident example

'''js
<EditIncident :Incident="Incident" />
'''
</docs>
